import Request from "../lib/request";
import {
  CHANGE_TEAM_PERMISSIONS_API,
  CHECK_PHONE_NUMBER_API,
  CONVERT_TO_ADMIN_API,
  CONVERT_TO_MANAGER_API,
  DEACTIVATE_API,
  DELETE_INVITATION_API,
  EDIT_ACCOUNTING_CODES_API,
  EDIT_IMPREST_PAYMENT_LIMIT_API,
  GET_ACCOUNTING_CODES_API,
  GET_IMPREST_PAYMENT_LIMIT_API,
  INIT_API,
  INVITE_API,
  INVITE_TO_OTHER_TEAMS_API,
  PROJECTS_API,
  REACTIVATE_API,
  REMOVE_FROM_TEAM_API,
  SHARED_PROJECTS_API,
  USER_MANAGEMENT_API,
  USERS_API
} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const userList = data => {
  return Request({
    method: "get",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${USERS_API}`,
    needToken: true,
    params: data
  });
};

export const checkPhoneNumber = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${CHECK_PHONE_NUMBER_API}`,
    needToken: true,
    data: data
  });
};

export const initInvite = data => {
  return Request({
    method: "get",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${INIT_API}`,
    needToken: true,
    params: data
  });
};

export const invite = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${INVITE_API}`,
    needToken: true,
    data: data
  });
};

export const reactivate = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${REACTIVATE_API}`,
    needToken: true,
    data: data
  });
};

export const deactivate = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${DEACTIVATE_API}`,
    needToken: true,
    data: data
  });
};

export const deleteInvitation = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${DELETE_INVITATION_API}`,
    needToken: true,
    data: data
  });
};

export const convertAdminToManager = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${CONVERT_TO_MANAGER_API}`,
    needToken: true,
    data: data
  });
};

export const convertManagerToAdmin = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${CONVERT_TO_ADMIN_API}`,
    needToken: true,
    data: data
  });
};

export const inviteManagerToOtherTeams = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${INVITE_TO_OTHER_TEAMS_API}`,
    needToken: true,
    data: data
  });
};

export const removeManagerFromTeam = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${REMOVE_FROM_TEAM_API}`,
    needToken: true,
    data: data
  });
};

export const changeTeamPermissions = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${CHANGE_TEAM_PERMISSIONS_API}`,
    needToken: true,
    data: data
  });
};

export const showUserProfile = userId => {
  return Request({
    method: "get",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${USERS_API}/${userId}`,
    needToken: true
  });
};

export const showProjectProfile = projectId => {
  return Request({
    method: "get",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${PROJECTS_API}/${projectId}`,
    needToken: true
  });
};

export const showProjectUserProfile = (userId, projectId) => {
  return Request({
    method: "get",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${USERS_API}/${userId}/${PROJECTS_API}/${projectId}`,
    needToken: true
  });
};

export const getSharedProjects = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${SHARED_PROJECTS_API}`,
    needToken: true
  });
};

export const getUserAccountingCodes = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${GET_ACCOUNTING_CODES_API}`,
    needToken: true,
    data: data
  });
};
export const editUserAccountingCodes = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${EDIT_ACCOUNTING_CODES_API}`,
    needToken: true,
    data: data
  });
};

export const getUserImprestPaymentLimit = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${GET_IMPREST_PAYMENT_LIMIT_API}`,
    needToken: true,
    data: data
  });
};
export const editUserImprestPaymentLimit = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USER_MANAGEMENT_API}/${EDIT_IMPREST_PAYMENT_LIMIT_API}`,
    needToken: true,
    data: data
  });
};
